import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/patreon': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M512 194.8C512 296.1 429.6 378.6 328.2 378.6 226.5 378.6 143.8 296.2 143.8 194.8 143.8 93.2 226.5 10.5 328.2 10.5 429.6 10.5 512 93.2 512 194.8zM0 501.5H90V10.5H0V501.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/patreon.js
// module id = KmVC
// module chunks = 144